<template>
	<hr
		class="divider"
		:style="cssVars"
		:class="customClasses"
	/>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    thickness: {
      default: '4px',
    },
    topMargin: {
      default: '80px',
    },
    bottomMargin: {
      default: '80px',
    },
    colour: {
      default: '#313032',
    },
    hide_on_mobile: {
      default: 'No',
    },
    hide_on_desktop: {
      default: 'No',
    },
  },

  computed: {
    cssVars() {
      return {
        '--thickness': this.thickness ? this.thickness : '4px',
        '--top-margin': this.topMargin ? this.topMargin : '80px',
        '--bottom-margin': this.bottomMargin ? this.bottomMargin : '80px',
        '--colour': this.colour ? this.colour : '#313032',
      };
    },

    customClasses() {
      return {
        hide_on_mobile: this.hide_on_mobile === '1',
        hide_on_desktop: this.hide_on_desktop === '1',
      };
    },
  },

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.divider {
  border: 0;
  border-top: var(--thickness) solid var(--colour);
  border-radius: 0;
  width: calc(100% - calc(var(--spacer) * 2));
  margin: var(--top-margin) auto var(--bottom-margin);
  position: relative;
  z-index: 15;
  max-width: var(--max-width);

  @media (max-width: $lg) {
    width: calc(100% - calc(var(--spacer) * 4));
    margin: calc(var(--top-margin) / 2) calc(var(--spacer) * 2)
      calc(var(--bottom-margin) / 2);
  }

  @media (max-width: $md) {
    width: calc(100% - calc(var(--spacer) * 2));
    margin: calc(var(--top-margin) / 2) calc(var(--spacer) * 1)
      calc(var(--bottom-margin) / 2);
  }

  &.hide_on_mobile {
    @media (max-width: $lg) {
      display: none;
    }
  }

  &.hide_on_desktop {
    @media (min-width: $lg) {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PageDivider.vue